import React from 'react';
import { ClickAwayListener } from '@material-ui/core';
import { metricDisplayValues } from '@linearb/linjs-common';
import StyledPopper from 'components/StyledPopper';
import MetricsBenchmarksTooltip from './MetricsBenchmarksTooltip';

const MetricsBenchmarkTooltip = ({
  value,
  metricName,
  anchorEl,
  onClose,
  definitionLevel,
  hideSettingsLink,
  granularity = null,
  calculationStrategy,
  popperPlacement = 'bottom-end'
}) => {
  const metricDisplayValue = metricDisplayValues[metricName];
  return (
    <StyledPopper
      id={'transitions-popper'}
      anchorEl={anchorEl}
      onClose={onClose}
      transition
      placement={popperPlacement}
      style={{ zIndex: 1000 }}
      width='56rem'
      height='unset'
      isTitleBorder={false}
      title={`Engineering Metrics Benchmarks: ${metricDisplayValue?.displayName}`}
    >
      <ClickAwayListener onClickAway={onClose}>
        <div>
          <MetricsBenchmarksTooltip
            value={value}
            metricName={metricName}
            definitionLevel={definitionLevel}
            hideSettingsLink={hideSettingsLink}
            granularity={granularity}
            calculationStrategy={calculationStrategy}
          />
        </div>
      </ClickAwayListener>
    </StyledPopper>
  );
};

export default MetricsBenchmarkTooltip;
